module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Preview"
    }
  }, [_c('table', {
    staticClass: "main_tbl"
  }, [_c('tr', [_c('td', {
    staticClass: "left_td"
  }, [_vm._v("Presenting Type")]), _vm._v(" "), _c('td', {
    staticClass: "right_td"
  }, [_vm._v(_vm._s(_vm.paper.paperForm))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "left_td"
  }, [_vm._v("Topic")]), _vm._v(" "), _c('td', {
    staticClass: "right_td"
  }, [_vm._v(_vm._s(_vm.paper.paperType))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "left_td"
  }, [_vm._v("NO")]), _vm._v(" "), _c('td', {
    staticClass: "right_td"
  }, [_vm._v(_vm._s(_vm.paper.paperNo))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "left_td"
  }, [_vm._v("Title")]), _vm._v(" "), _c('td', {
    staticClass: "right_td"
  }, [_vm._v(_vm._s(_vm.paper.paperTitle))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "left_td"
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('td', {
    staticClass: "right_td"
  }, [_vm._v(_vm._s(_vm.paper.paperKeyword))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "left_td"
  }, [_vm._v("Content")]), _vm._v(" "), _c('td', {
    staticClass: "right_td"
  }, [_vm._v(_vm._s(_vm.paper.paperSummary) + "\n\t\t\t\t")])]), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('tr', [_c('td', {
      staticClass: "left_td"
    }, [_vm._v("Attachment " + _vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "right_td"
    }, [_c('a', {
      attrs: {
        "href": file.fileUrl,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(file.fileOrig))])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "left_td"
  }, [_vm._v("Conflict of Interest Disclosure:")]), _vm._v(" "), _c('td', {
    staticClass: "right_td",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.single),
      expression: "single"
    }],
    staticClass: "magic-radio",
    attrs: {
      "type": "radio",
      "name": "radio6",
      "id": "1",
      "value": "sect"
    },
    domProps: {
      "checked": _vm._q(_vm.single, "sect")
    },
    on: {
      "change": function($event) {
        _vm.single = "sect"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("I declare that my presentation will be objective and free of commercial bias. ")]), _vm._v(" "), _vm._v("\n\t\t\t\t\tAll the information regarding commercial products or services is based on scientific methods generally accepted by the medical community.\n\t\t\t\t")])])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btm"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Save and Next")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6345eaa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paper/Preview.vue
// module id = 807
// module chunks = 10